import {
  RadioConditionName,
  CheckConditionName,
  RangeConditionName,
  PeriodConditionName,
  RangeParams,
  PeriodParams,
  Option,
} from '../actions'
import {
  TYPES,
  SHAREHOLDER_STATUS_OPTIONS,
  ORIGIN_OPTIONS,
  INSTITUTE_OPTIONS,
  INDUSTRY_OPTIONS,
  MARKET_OPTIONS,
  RESEARCH_STATUS_CATEGORY,
  IPO_CATEGORY_OPTIONS,
  ESTABLISHED_DATE_OPTIONS,
  LAST_FUNDRAISED_OPTIONS,
  IPOED_DATE_OPTIONS,
  TOTAL_FUNDINGS_OPTIONS,
  EMPLOYEES_OPTIONS,
  STATE_OPTIONS,
  INITIAL_SERIES_OPTIONS,
  VALUATION_OPTIONS,
  STATUS_UPDATED_DATE_OPTIONS,
  FIRST_INTERVIEW_DATE_OPTIONS,
  COUNTRY_OPTIONS,
  CB_LATEST_ROUND_TYPE_OPTIONS,
} from './options'
import { fromEntries } from '../utils'
import _ from 'lodash'

export type LabelOption = {
  label: string
}

// type RangeOption = LabelOption & {
//   range: {
//     from: null | number
//     to: null | number
//   }
// }
// type PeriodOption = LabelOption & {
//   period: {
//     from: null | string
//     to: null | string
//   }
// }
// type ConditionData<TOption> = {
//   label: string
//   options: TOption
// }
export type SelectConditionName = CheckConditionName | RadioConditionName
export type SelectOptions =
  | keyof typeof TYPES
  | keyof typeof INITIAL_SERIES_OPTIONS
  | keyof typeof SHAREHOLDER_STATUS_OPTIONS
  | keyof typeof ORIGIN_OPTIONS
  | keyof typeof INSTITUTE_OPTIONS
  | keyof typeof INDUSTRY_OPTIONS
  | keyof typeof MARKET_OPTIONS
  | keyof typeof RESEARCH_STATUS_CATEGORY
  | keyof typeof IPO_CATEGORY_OPTIONS
  | keyof typeof CB_LATEST_ROUND_TYPE_OPTIONS
// type SelectConditionOptionMap = { [key in SelectOptions]?: LabelOption }
// type ConditionItems = {
//   [key in RangeConditionName]: ConditionData<RangeOption[]>
// } &
//   { [key in PeriodConditionName]: ConditionData<PeriodOption[]> } &
//   { [key in SelectConditionName]: ConditionData<SelectConditionOptionMap> }

const allSelectOptions = [
  TYPES,
  INITIAL_SERIES_OPTIONS,
  SHAREHOLDER_STATUS_OPTIONS,
  ORIGIN_OPTIONS,
  INSTITUTE_OPTIONS,
  INDUSTRY_OPTIONS,
  MARKET_OPTIONS,
  RESEARCH_STATUS_CATEGORY,
  IPO_CATEGORY_OPTIONS,
  STATE_OPTIONS,
  COUNTRY_OPTIONS,
  CB_LATEST_ROUND_TYPE_OPTIONS,
]

export const isSelectOption = (
  maybeOption: string
): maybeOption is SelectOptions => {
  return allSelectOptions.some((options) => {
    return Object.keys(options).includes(maybeOption)
  })
}

type SelectOptionTuple = [SelectOptions, LabelOption]
const isSelectOptionTuple = (item: any): item is SelectOptionTuple => {
  const [option, value] = item
  return !!value && isSelectOption(option)
}

export const getSelectCondtionOptions = (optionName: SelectConditionName) => {
  const { options } = CONDITION_ITEMS[optionName]
  const list: SelectOptionTuple[] = Object.entries(options).filter(
    (item): item is SelectOptionTuple => isSelectOptionTuple(item)
  )
  return list
}

export const RADIO_CONDITION_ITEMS = {
  type: { label: 'タイプ', options: TYPES },
}

export const PERIOD_CONDITION_ITEMS = {
  established: { label: '設立年月日', options: ESTABLISHED_DATE_OPTIONS },
  lastFundraised: {
    label: '最新ラウンド調達日',
    options: LAST_FUNDRAISED_OPTIONS,
  },

  ipoed: { label: 'IPO年月日', options: IPOED_DATE_OPTIONS },
  statusUpdated: {
    label: 'ステータス更新日',
    options: STATUS_UPDATED_DATE_OPTIONS,
  },
  firstInterviewDate: {
    label: '初回面談日',
    options: FIRST_INTERVIEW_DATE_OPTIONS,
  },
}

export const AMOUNT_RANGE_CONDITION_ITEMS = {
  totalFunding: { label: '総調達額', options: TOTAL_FUNDINGS_OPTIONS },
  valuation: { label: '調達後評価額', options: VALUATION_OPTIONS },
}
export const PEOPLE_RANGE_CONDITION_ITEMS = {
  employees: { label: '従業員数', options: EMPLOYEES_OPTIONS },
}

export const CHECK_CONDITION_ITEMS = {
  latestInitialSeries: {
    label: 'スピーダ調達シリーズ',
    options: INITIAL_SERIES_OPTIONS,
  },
  shareholderStatus: { label: '株主状況', options: SHAREHOLDER_STATUS_OPTIONS },
  origin: { label: '起源', options: ORIGIN_OPTIONS },
  institute: { label: '大学・研究機関', options: INSTITUTE_OPTIONS },
  industry: { label: '業種', options: INDUSTRY_OPTIONS },
  market: { label: 'IPO市場', options: MARKET_OPTIONS },
  ipoCategory: { label: 'IPO区分', options: IPO_CATEGORY_OPTIONS },
  state: { label: '都道府県', options: STATE_OPTIONS },
  country: { label: '国・地域', options: COUNTRY_OPTIONS },
  researchStatusCategory: {
    label: '調査状況',
    options: RESEARCH_STATUS_CATEGORY,
  },
  cbLatestRoundType: {
    label: 'Crunchbase最新ラウンドタイプ',
    options: CB_LATEST_ROUND_TYPE_OPTIONS,
  },
}

const __CONDITION_ITEMS = {
  ...RADIO_CONDITION_ITEMS,
  ...PERIOD_CONDITION_ITEMS,
  ...AMOUNT_RANGE_CONDITION_ITEMS,
  ...PEOPLE_RANGE_CONDITION_ITEMS,
  ...CHECK_CONDITION_ITEMS,
}

type ConditionKeys = keyof typeof __CONDITION_ITEMS

export const ConditionOrderPriority: { [k in ConditionKeys]: number } = {
  type: 1,
  latestInitialSeries: 2,
  cbLatestRoundType: 3,
  totalFunding: 4,
  valuation: 5,
  lastFundraised: 6,
  country: 7,
  state: 8,
  established: 9,
  employees: 10,
  industry: 11,
  origin: 12,
  institute: 13,
  shareholderStatus: 14,
  ipoCategory: 15,
  ipoed: 16,
  market: 17,
  researchStatusCategory: 18,
  statusUpdated: 19,
  firstInterviewDate: 20,
}

// CONDITION_ITEMSの内部の要素を種別ごとに分解して扱いたかったが、順序が保証されないので外向けには並べ直している
export const CONDITION_ITEMS = fromEntries(
  Object.entries(__CONDITION_ITEMS).sort(
    ([aKey], [bKey]) =>
      ConditionOrderPriority[<ConditionKeys>aKey] -
      ConditionOrderPriority[<ConditionKeys>bKey]
  )
)

export const CONDITION_ITEMS_FOR_CONDITION_SELECTOR = fromEntries(
  Object.entries(
    _.omit(__CONDITION_ITEMS, ['statusUpdated', 'firstInterviewDate'])
  ).sort(
    ([aKey], [bKey]) =>
      ConditionOrderPriority[<ConditionKeys>aKey] -
      ConditionOrderPriority[<ConditionKeys>bKey]
  )
)

type RangeConditions = { [key in RangeConditionName]?: RangeParams }
type PeriodConditions = { [key in PeriodConditionName]?: PeriodParams }
type CheckConditions = { [key in CheckConditionName]?: Option[] }
type RadioConditions = { [key in RadioConditionName]?: Option[] }

export type Conditions = RangeConditions &
  CheckConditions &
  PeriodConditions &
  RadioConditions
